import styled from 'styled-components';
import GuideBox from '../components/guide/GuideBox';

const QuantGuideList = [
  {
    number: '❷',
    text: `선택한 테마주의 지역별, 부동산 유형별 수익률을 확인할 수 있습니다. 테마주는 자유롭게 추가하거나 제외하면서 수익률을 확인하며 전략을 수정할 수 있습니다.\n(구매 유료 요금제별 일부 지역 수익률만 조회 가능)`,
  },
  {
    number: '❸',
    text: `해당 테마주 전략으로 수익성이 있는 물건을 추천 받을 수 있습니다.\n부동산 유형, 소재지는 물론 투자성향, 예상가, 예상 수익률 등을 확인 후 전문가급 상세 리포트 분석을 열람할 수 있습니다.`,
  },
  {
    number: '❹',
    text: '분석 리포트에서 예상 보유 기간, 예상 가격 분석, 예상 비용 분석, 수익률 시뮬레이션 등 전문가급 퀀트 투자 전략을 확인할 수 있습니다.',
  },
];

function QuantGuide() {
  return (
    <Box gap={64}>
      <Box gap={14}>
        <GuideBox
          title="퀀트 기반 테마 분석"
          description={`복잡한 설정 없이, 이미 검증된\n빅데이터 전략으로 경매 물건을 추천 받아보세요.`}
          subDescription="수십 년 축적된 데이터를 통해 가장 돈 되는 테마별 포트폴리오를 제시합니다."
          urls={[{ title: '퀀트 기반 테마 분석', url: '/quant' }]}
          img="/assets/images/guide/Guide_03_1.png"
        />
        <ImageDescription>
          <span>❶</span>분석하고 싶은 테마주를 선택합니다. 테마주는 단일건도,
          2개 이상의 복합 물건 조합으로도 분석이 가능합니다.
        </ImageDescription>
      </Box>
      {QuantGuideList.map(({ number, text }, idx) => (
        <Box gap={14}>
          <img
            src={`/assets/images/guide/Guide_03_${idx + 2}.png`}
            style={{ width: '100%' }}
          />
          <ImageDescription>
            <span>{number}</span>
            {text}
          </ImageDescription>
        </Box>
      ))}
    </Box>
  );
}

export default QuantGuide;

const Box = styled.div<{ gap?: number }>`
  display: flex;
  flex-direction: column;
  gap: ${({ gap }) => `${gap}px`};
`;

const ImageDescription = styled.div`
  display: flex;
  flex-direction: row;
  gap: 4px;
  font-family: Spoqa Han Sans Neo;
  font-weight: 500;
  font-size: 16px;
  line-height: 145%;
  letter-spacing: -2%;
  color: #616161;
  white-space: pre-line;

  span {
    color: #008aff;
  }
`;
